export enum DrawingType {
    Public = "Public",
    Protected = "Protected",
    Private = "Private",
}